import { useState } from "react";
import { deleteUserURL } from "../../utils/ConstantsURL";

export const useDeleteUser = (token) => {
  const [loading, setLoading] = useState(false);

  const deleteUser = async (id) => {
    setLoading(true);
    try {
      let response = await fetch(deleteUserURL(id), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      let data = await response.json();
      if (!response.ok) {
        throw new Error(data.message);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error al eliminar el usuario:", error);
    } finally {
      setLoading(false);
    }
  };

  return { deleteUser, loading };
};
